export default __webpack_public_path__ + "static/spaghetti-with-meatballs-125645013a7fd3786168c1e806f253db.jpeg";